import OffersPro from "page/OffersPro";
import React from "react";
import formatUrl from "utils/FormatUrl";
import style from "./Item.module.css";
import Image from "next/image";

function Item(props) {
  return (
    <div
      className={`
        ${style.container} 
        ${props.offersPro ? style.containerPro : ""}
        ${props.temoignages ? style.containerTemo : ""}
        ${props.index === 0 ? style.reversePro : style.backgroundGray}
        ${props.credit ? style.bgWhite : ""}
        `}
    >
      <div
        className={`${style.img} ${props.offersPro ? style.imgPro : ""} ${
          props.video_link?.length > 0 ? style.isVideo : ""
        }`}
      >
        {props.video_link?.length > 0 ? (
          <iframe
            title="My Video"
            style={{ border: "none" }}
            src={`${props.video_link}?modestbranding=1&rel=0;autoplay;encrypted-media;gyroscope;picture-in-picture`}
            allowFullScreen
          />
        ) : (
          <>
            <img
              src={props.image}
              alt={props.title}
              width={props.width}
              height={props.height}
            />
            {/* <Image
              src={props.image}
              alt={props.title}
              layout=""
            /> */}
          </>
        )}
        {props.video_owner?.length > 0 && props.video_owner_adress?.length ? (
          <div className={style.ownerInfos}>
            <p className={style.videoOwner}>{props.video_owner}</p>
            <p className={style.videoAdress}>{props.video_owner_adress}</p>
          </div>
        ) : null}
      </div>
      <div
        className={`${style.actionSection} ${
          props.temoignages ? style.actionSectionTem : ""
        } `}
      >
        {props.offersPro || props.temoignages ? (
          <div
            className={`${props.temoignages ? style.barraBlue : style.barra}`}
          ></div>
        ) : null}
        <p className={style.title}>{props.title}</p>
        <p className={style.description}>{props.description}</p>
        {!props.temoignages ? (
          <a
            href={
              props.offersPro
                ? formatUrl(props.button_link, props.lang)
                : formatUrl(props.button_link, props.lang)
            }
            target="_blank"
            className={`${style.button} ${
              props.offersPro ? style.btnBlue : ""
            }`}
          >
            {props.buttonText}
          </a>
        ) : null}
      </div>
    </div>
  );
}

export default Item;
